import CondicaoService from "@/services/CondicaoService";

export const condicao = {
  namespaced: true,
  state: {
    condicao: {},
  },
  actions: {
    getCondicao({ commit }, payload) {
      return CondicaoService.GetCondicao(payload).then(
        (condicao) => {
          return Promise.resolve(condicao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postCondicao({ commit }, payload) {
      return CondicaoService.PostCondicao(payload).then(
        (condicao) => {
          return Promise.resolve(condicao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putCondicao({ commit }, payload) {
      return CondicaoService.PutCondicao(payload).then(
        (condicao) => {
          return Promise.resolve(condicao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteCondicao({ commit }, payload) {
      return CondicaoService.DeleteCondicao(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getCondicaoOData({ commit }, payload) {
      return CondicaoService.GetCondicaoOData(payload).then(
        (condicao) => {
          return Promise.resolve(condicao);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default condicao;
